import { useCallback, useState } from "react";

import { strCode } from "../../consts";
import { log, notificationService, t, usersService } from "../../services";
import { responseUtil } from "../../utils";

export const useResetPassword = () => {
  const [loading, setLoading] = useState();

  const mutationCallback = useCallback(async (userEmail) => {
    setLoading(true);
    try {
      const res = await usersService.resetUserPassword(userEmail);

      if (responseUtil.isResponseSuccessful(res)) {
        notificationService.showSuccess({
          title: t(strCode.RESET_USER_PASSWORD_SUCCESS),
          message: t(strCode.RESET_USER_PASSWORD_SUCCESS_INFO)
        });
      }
    } catch (err) {
      log.error("useResetPassword: Failed to reset user password", err);

      notificationService.showError({
        title: t(strCode.RESET_USER_PASSWORD_ERROR),
        message: err?.response?.data?.message ? err.response.data.message : err?.toString()
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return { mutationCallback, loading };
};
